import dayjs from "dayjs";
import "dayjs/locale/id";

const formatDate = (value: string | Date, timezone: number) => {
  return dayjs(value).locale("id").add(timezone, "hour").format("DD MMMM YYYY");
};

export const formatEventDateRange = (
  startDate: string | Date,
  endDate: string | Date,
  timezone = 7,
) => {
  const start = dayjs(startDate).add(timezone, "hour");
  const end = dayjs(endDate).add(timezone, "hour");

  if (start.isSame(end, "day")) {
    return formatDate(startDate, timezone);
  }

  if (start.isSame(end, "month") && start.isSame(end, "year")) {
    return `${start.locale("id").format("DD")} - ${end
      .locale("id")
      .format("DD MMMM YYYY")}`;
  }

  if (start.isSame(end, "year")) {
    return `${start.locale("id").format("DD MMMM")} - ${end
      .locale("id")
      .format("DD MMMM YYYY")}`;
  }

  return `${start.locale("id").format("DD MMMM YYYY")} - ${end
    .locale("id")
    .format("DD MMMM YYYY")}`;
};
